<template>
  <AppSection class="relative">
    <AppContainer end>
      <h2>{{ $tt('blog.recent') }}</h2>
      <AppCarousel
        :breakpoints="{
          851: { itemsToShow: 2.3 },
          1000: { itemsToShow: 2.6 },
          1250: { itemsToShow: 3.1 },
          1550: { itemsToShow: 3.8 },
          2000: { itemsToShow: 4 },
        }"
        snap-align="start"
        wrap-around navigation end elevated
      >
        <AppCarouselSlide v-for="post in posts" :key="post.id">
          <ArticleCard :post has-excerpt white />
        </AppCarouselSlide>
      </AppCarousel>
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import type { BlogPost } from '~/types';
import { AppCarousel } from '#components';

defineProps<{
  posts: BlogPost[];
}>();
</script>